import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AppPreviewSection from './components/AppPreviewSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import CoachingStylesSection from './components/CoachingStylesSection';
import HowItWorksSection from './components/HowItWorksSection';
import FeaturesSection from './components/FeaturesSection';
import UseCasesSection from './components/UseCasesSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import ExampleInteractionSection from './components/ExampleInteractionSection';
import TransformationPromiseSection from './components/TransformationPromiseSection';
import PricingSection from './components/PricingSection';
import DisclaimerSection from './components/DisclaimerSection';
import FinalCTASection from './components/FinalCTASection';
import KnowledgeCatalogueSection from './components/KnowledgeCatalogueSection';
import FooterSection from './components/FooterSection';
import useSeo, { SITE_URL } from '@/hooks/useSeo';

export default function Home() {
  useSeo({
    title: 'TNT Coach AI - Top Notch Transformation Self-Coaching Companion',
    description: 'Break procrastination, build confidence, design consistent habits, and unlock peak performance with instant, action-oriented AI coaching workflows from Top Notch Technologies.',
    canonical: `${SITE_URL}/`,
    url: `${SITE_URL}/`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20brand%20banner%20in%20deep%20charcoal%20black%20and%20warm%20golden%20amber%20tones%2C%20soft%20gradient%20light%20rays%20and%20minimal%20geometric%20shapes%20suggesting%20upward%20growth%20and%20personal%20transformation%2C%20premium%20editorial%20style%2C%20generous%20negative%20space%2C%20sophisticated%20modern%20aesthetic%2C%20high%20detail&width=1200&height=630&seq=tnt-coach-og-image&orientation=landscape',
  });

  // Arriving from a legacy redirect like /pricing (which forwards to /#pricing)
  // or from an external deep link: the browser only scrolls to an anchor on a
  // fresh document load, so client-side hops need this nudge.
  useEffect(() => {
    const id = window.location.hash.replace('#', '');
    if (!id) return;
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 120);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-midnight">
      <Navbar />
      <main>
        <HeroSection />
        <AppPreviewSection />
        <ProblemSection />
        <SolutionSection />
        <CoachingStylesSection />
        <HowItWorksSection />
        <FeaturesSection />
        <UseCasesSection />
        <BeforeAfterSection />
        <ExampleInteractionSection />
        <TransformationPromiseSection />
        <PricingSection />
        <DisclaimerSection />
        <FinalCTASection />
      </main>
      <KnowledgeCatalogueSection />
      <FooterSection />
    </div>
  );
}